import React from 'react';

const Contact = () => {
  return (
    <section id="main">
            
    <div>   
    <h3>Contact Us</h3>
    <p>
    Forest Hills Cemetery is a not-for-profit trusteed association. Please contact the office with any questions you may have concerning plots or existing burial sites.
    </p>
    <a href="mailto:name@example.com?subject=Forest Hills Cemetery Bio 20509 MALCOM, CHARLOTTE BRODGEN 1937-02-07&body=Occupation: %0D%0APIN (please don't remove): 20509%0D%0AFirst name: CHARLOTTE BRODGEN%0D%0ALast name: MALCOM%0D%0AComments/biography:%0D%0ADate of birth:%0D%0ADate of death:%0D%0ARelationship:">CLICK ME</a>
    <h3>Address</h3>
    <p>
    Forest Hills Cemetery<br />
    4016 Tennessee Avenue<br />
    Chattanooga, Tennessee 37409<br />
    Phone: 423.821.4161<br />
    Fax: 423.821.8740<br />
    <a href="mailto:foresthillscemetery@gmail.com?subject=Forest Hills Cemetery Website Inquiry">foresthillscemetery@gmail.com</a>
    </p>
    </div>
    <div>
    <h3>Hours</h3>
    <p align="justify">
    The cemetery is open for the public from<br />8 am until 6 pm 365 days a year.<br />
    The office is open during the following hours:<br />
    <b>8:30 am - 4:30 pm Monday through Thursday</b><br />
    <b>8:30 am - 4:00 pm Friday</b><br />
    <b>The office is closed on Saturday and Sunday</b>
    </p>
    </div>
    <div>
     &nbsp;
    </div>
     <div>
    <img alt="Cemetery Map" width="300" src="./images/staticmap.gif" />
    </div>
     <br />
    <div>
    <h3>Directions</h3>
    <p align="justify"><b>From Knoxville:</b><br />
    Take I-40 west until the 40/75 split. Take I-75 south towards Chattanooga. At the I-75/I-24 split, take I-24 west towards downtown Chattanooga. Get off at exit 178 south, the Lookout Mountain/Market Street exit. Go straight to the traffic light on Broad Street and take a left. Follow the sign to Rock City. Go through two traffic lights and take the first street on the left. Forest Hills Cemetery is on the left at the top of the hill.
    </p>
    <p align="justify"><b>From Atlanta:</b><br />
    Take I-75 north all the way to Chattanooga. At the I-75/I-24 split, take I-24 west towards downtown Chattanooga. Get off at exit 178 south, the Lookout Mountain/Market Street exit. Go straight to the traffic light on Broad Street and take a left. Follow the sign to Rock City. Go through two traffic lights and take the first street on the left. Forest Hills Cemetery is on the left at the top of the hill. 
    </p>
    <p align="justify"><b>From Birmingham/Nashville:</b><br />
    Take I-59 north to I-24 east towards Chattanooga. Continue on I-24 east until exit 174. Turn right onto US 64, 41 and remain on US 41 until you come to the intersection of Broad Street and Tennessee Avenue. Take a right onto Tennessee Avenue. Follow the sign to Rock City. Go through two traffic lights and take the first street on the left. Forest Hills Cemetery is on the left at the top of the hill. 
    </p>
    </div>
            </section>
    )
}

export default Contact
